module.exports = __webpack_public_path__ + "assets/img/aboutUS-module1-2.476fb0a2.jpg";